import React from "react";
import { Address } from "../../../domain/models/address";
import CartContext, { CartState } from "./CartContext";

export default React.createContext<CartContext>({
  state: { cart: { products: [], address: {} as Address } } as CartState,
  dispatch: () => {},
});
